import router from '../services/router_service';
import magazineController from '../controllers/author_controller';

router.on('route:magazine', magazineController);
